<div class="mat-elevation-z8 table-container position-relative" style="z-index: 0;">
  <div class="position-absolute" style=" top: 0px; right: 0px; z-index: 99999;">

    <mat-menu #menuDownload="matMenu" xPosition="before">
            <button mat-menu-item (click)="compinedPDF()"> 
        <img src="assets/icons/download_material.svg" height="24"/>
        <span>Mappe</span>
      </button>
      <!-- erst mal außen vor -->
      <button mat-menu-item (click)="downloadMQReport('csv')">
        <img src="assets/icons/download_material.svg" height="24"/>
        <span>CSV</span>
      </button>
      <button mat-menu-item (click)="downloadMQReport('ascii')">
        <img src="assets/icons/download_material.svg" height="24"/>
        <span>ASCII</span>
      </button>
      <button mat-menu-item (click)="downloadMQReport('pdf')">
        <img src="assets/icons/download_material.svg" height="24"/>
        <span>PDF</span>
      </button>
    </mat-menu>
  </div>
  <table mat-table [dataSource]="dataSource!" matSort class="mat-elevation-z8">


    <ng-container matColumnDef="timestampFrom">
      <th mat-header-cell *matHeaderCellDef> Zeitpunkt </th>
      <td mat-cell *matCellDef="let element"> {{element.timestampFrom | date: 'dd.MM.yyyy - H:mm' }} </td>
    </ng-container>

    <ng-container matColumnDef="pkwTrafficVolume">
      <th mat-header-cell *matHeaderCellDef> Anzahl PKW </th>
      <td mat-cell *matCellDef="let element"> {{element.trafficData.pkwTrafficVolume}} </td>
    </ng-container>

    <ng-container matColumnDef="lkwTrafficVolume">
      <th mat-header-cell *matHeaderCellDef> Anzahl LKW </th>
      <td mat-cell *matCellDef="let element"> {{element.trafficData.lkwTrafficVolume}} </td>
    </ng-container>

    <ng-container matColumnDef="kfzTrafficVolume">
      <th mat-header-cell *matHeaderCellDef> Anzahl KFZ </th>
      <td mat-cell *matCellDef="let element"> {{element.trafficData.kfzTrafficVolume}} </td>
    </ng-container>

    <ng-container matColumnDef="pkwAverageSpeed">
      <th mat-header-cell *matHeaderCellDef> Durchschnittsgeschwindigkeit PKW in km/h </th>
      <td mat-cell *matCellDef="let element"> {{element.trafficData.pkwAverageSpeed}} </td>
    </ng-container>

    <ng-container matColumnDef="lkwAverageSpeed">
      <th mat-header-cell *matHeaderCellDef> Durchschnittsgeschwindigkeit LKW in km/h </th>
      <td mat-cell *matCellDef="let element"> {{element.trafficData.lkwAverageSpeed}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <button mat-icon-button [matMenuTriggerFor]="menuDownload" aria-label="Download menu">
          <img src="assets/icons/download_material.svg" height="24"/>
        </button>
      </th>
      <td mat-cell *matCellDef="let element"> </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

</div>